"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversations.error.failedToLoad': '加载对话失败',
    'conversations.error.failedToDelete': '删除对话失败',
    'conversations.error.failedToToggleFavorite': '切换收藏状态失败',
};
